import { render, staticRenderFns } from "./ObjectifLuneProducts.vue?vue&type=template&id=23a88336&scoped=true&"
import script from "./ObjectifLuneProducts.vue?vue&type=script&lang=js&"
export * from "./ObjectifLuneProducts.vue?vue&type=script&lang=js&"
import style0 from "./ObjectifLuneProducts.vue?vue&type=style&index=0&id=23a88336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a88336",
  null
  
)

export default component.exports